<template>
    <DataTable
        :header="$t('currentProductAvailability')"
        :fields="fields"
        :items="items"
        :loading="request.getLoading()"
        :error="request.getError()"
        class="mb-4"
    >
        <template v-for="campaign in campaigns" #[`cell(campaign-${campaign.id})`]="{value}">
            <div :key="campaign.id" class="text-center">
                <feather v-if="value" type="check" class="text-success" />
                <feather v-else type="x" class="text-danger" />
            </div>
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'CurrentProductsAvailability',
        components: {
            DataTable,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestCurrentProductsAvailability,
            };
        },
        computed: {
            campaigns() {
                return this.parentComponent.requestCampaigns.getData() || [];
            },
            selectedCampaigns() {
                return this.parentComponent.campaigns || [];
            },
            selectedStoreCampaigns() {
                if (this.selectedCampaigns.length > 0) {
                    return this.campaigns.filter(campaign => this.selectedCampaigns.includes(campaign.id));
                }
                return this.campaigns;
            },
            data() {
                return this.request.getData() || {};
            },
            fields() {
                const staticFields = [
                    { key: 'category', label: this.$t('category'), sortable: true },
                    { key: 'productName', label: this.$t('product'), sortable: true },
                    { key: 'sku', label: this.$t('model'), sortable: true },
                    { key: 'ean', label: 'EAN', sortable: true },
                ];
                const dynamicFields = this.selectedStoreCampaigns.map(campaign => ({
                    key: `campaign-${campaign.id}`,
                    label: campaign.name,
                    sortable: true,
                }));
                return [...staticFields, ...dynamicFields];
            },
            items() {
                const items = [];
                Object.values(this.data).forEach(productObj => {
                    const product = productObj.product || {};
                    let category = '';
                    if (product.categories && product.categories.length > 0 && product.categories[0].length > 0) {
                        category = product.categories[0][product.categories[0].length - 1].name || '';
                    }
                    const row = {
                        category,
                        productName: product.name || '',
                        sku: product.sku || '',
                        ean: product.ean || '',
                    };
                    this.selectedStoreCampaigns.forEach(campaign => {
                        const key = `campaign-${campaign.id}`;
                        const available = productObj.availabilities ? productObj.availabilities[key] : false;
                        row[key] = available;
                    });
                    items.push(row);
                });
                return items;
            },
        },
    };
</script>
